export const BANDWIDTH_VALUES = ['400', '850'];

export const ga2ProductMap = {
  'ga2-n257': 'n257',
  'ga2-n260': 'n260'
};

export const formatOptions = (options = []) => {
  return options.map((option) => {
    return { label: option.toString(), value: option };
  });
};

export const filterAndFormatOptions = (arfcnValues = []) => {
  return arfcnValues.map((item) => ({
    ...item,
    label: `${item.displayValue} (${item.arfcn})`,
    value: item.arfcn
  }));
};

export const findArfcnByCenterFreq = (displayValue, arfcnValues = []) => {
  if (!arfcnValues) return null;
  const foundItem = arfcnValues.find((item) => item.displayValue === displayValue);
  return foundItem ? foundItem.arfcn : null;
};

export const findCenterFreqByArfcn = (arfcn, arfcnValues = []) => {
  if (!arfcnValues) return null;
  const foundItem = arfcnValues.find((item) => item.arfcn === arfcn);
  return foundItem ? foundItem.displayValue : null;
};
